import { createFileRoute } from '@tanstack/react-router';
import { strategiesAtom } from 'r/atoms';
import { useAtomValue } from 'jotai';

export const Route = createFileRoute('/(admin)/mcp')({
  component: RouteComponent,
});

function RouteComponent() {
  const strategies = useAtomValue(strategiesAtom);
  return (
    <div className="h-screen flex flex-col items-center justify-center pt-10">
      <div>
        {strategies
          .filter((s) => s.source === 'mcp')
          .map(({ issuerId, portfolioID, source }, idx) => (
            <a
              className="block text-h-5 text-center h-12 hover:text-blue-400"
              key={idx}
              href={`/${issuerId}/${portfolioID}?source=${source}`}
            >
              {portfolioID}
            </a>
          ))}
      </div>
    </div>
  );
}
